'use client';

import Link from 'next/link';
import { useState } from 'react';
import { HiChevronDown, HiPhone } from 'react-icons/hi';

import LocationSchedule from 'src/components/LocationSchedule';
import { locationUrl } from 'src/services/route-utils';

type Props = {
    location: any;
};

export default function LocationCard({ location }: Props) {
    const [collapsed, setCollapsed] = useState(true);

    return (
        <div className="relative mt-4 bg-white p-4 md:p-8">
            <HiChevronDown
                aria-hidden
                onClick={() => setCollapsed(!collapsed)}
                className={`absolute right-4 top-4 cursor-pointer text-2xl transition duration-200 ease-out md:top-8 ${
                    collapsed ? '' : ' rotate-180'
                }`}
            />
            <div className="cursor-pointer items-center gap-8 md:flex" onClick={() => setCollapsed(!collapsed)}>
                <h4
                    className={`text-primary pr-4 text-lg md:w-1/2 md:pr-0 md:text-xl${
                        collapsed ? '' : ' underline decoration-1 underline-offset-4'
                    }`}>
                    {location.name}
                </h4>
                <div className={`hidden md:w-1/2 ${collapsed ? 'md:flex' : ''}`}>
                    {location.phone?.map((phone) => (
                        <div className="w-1/2" key={phone}>
                            <HiPhone className="mr-2 inline" />
                            {phone}
                        </div>
                    ))}
                </div>
            </div>
            {!collapsed && (
                <>
                    <div className="mt-4 gap-4">
                        <div className="mb-4">{location.address}</div>
                        <LocationSchedule
                            location={location}
                            layout="horizontal"
                            justifyCenter={false}
                            headingsClassName="font-display text-lg text-primary"
                        />
                        <div className="my-4 flex-1 md:my-0"></div>
                    </div>
                    <div className="mt-4 gap-4 md:flex">
                        {location.phone?.map((phone) => (
                            <a
                                href={`tel:${phone.replace(/-/g, '')}`}
                                key={phone}
                                className="btn btn-primary mt-2 block">
                                <HiPhone className="mr-2 inline" />
                                {phone}
                            </a>
                        ))}
                        <Link
                            className="text-primary border-primary mt-2 block rounded-full border p-2 px-10 text-center"
                            href={locationUrl(location)}>
                            Vezi locația
                        </Link>
                    </div>
                </>
            )}
        </div>
    );
}
